// API CLIENT  ACTIONS:
export const SET_VARIABLE_FIELDS = "SET_VARIABLE_FIELDS";
export const SET_API_CLIENT_PAYLOAD = "SET_API_CLIENT_PAYLOAD";
export const ADD_REQUEST_PARAMETER = "ADD_REQUEST_PARAMETER";
export const REMOVE_REQUEST_PARAMETER = "REMOVE_REQUEST_PARAMETER";
export const ONCHANGE_HANDLER = "ONCHANGE_HANDLER";
export const ADD_UPDATE_API_COLLECTION = "ADD_UPDATE_API_COLLECTION";
export const REMOVE_API_COLLECTION = "REMOVE_API_COLLECTION";
export const SET_SELECTED_COLLECTION = "SET_SELECTED_COLLECTION";
export const SET_API_RESPONSE = "SET_API_RESPONSE";
export const SET_RELATED_WINDOW_FIELDS = "SET_RELATED_WINDOW_FIELDS";
export const SET_DEFAULT_CONTENT_TYPE = "SET_DEFAULT_CONTENT_TYPE";
export const SET_AUTO_MAPPING_FIELDS = "SET_AUTO_MAPPING_FIELDS";
export const SET_FORMULA_FIELD_DATA = "SET_FORMULA_FIELD_DATA";
export const SET_VARIABLES_PAYLOAD = "SET_VARIABLES_PAYLOAD";
export const SET_MAPPING_FIELD_DATA = "SET_MAPPING_FIELD_DATA";
export const SET_AUTO_MAPPING_FILTERED_FIELDS = "SET_AUTO_MAPPING_FILTERED_FIELDS";
export const SET_ARRAY_OBJECT_FIELDS = "SET_ARRAY_OBJECT_FIELDS";
export const SET_WINDOW_FIELDS = "SET_WINDOW_FIELDS";
export const SET_INPUT_VARIABLES = "SET_INPUT_VARIABLES";

  
